import { Box } from "@material-ui/core";
import { useTheme } from "@material-ui/styles";
import { assetIds, ThemedAsset } from "nemuru-components";
import React from "react";
import { ICON_TITLE_HEIGHT } from "../../../../../../../config/config";
import IconTitle from "../../../../../../shared/components/IconTitle";
import Text from "../../../../../../shared/components/Text";
import { AddressComplementForm } from "./components/AddressComplementForm";
import { AddressComplementFormWrapper } from "./components/AddressComplementFormWrapper";
import { AddressComplementFormSubmitter } from "./components/AddressComplementFormSubmitter";

export default function AdditionalDataAddressComplement({
  onSubmitForm,
  data,
}) {
  const { palette } = useTheme();
  return (
    <>
      <AddressComplementFormWrapper data={data}>
        <Box className="appear-anim">
          <IconTitle
            icon={
              <ThemedAsset
                id={assetIds.ICON_ID_LOCATION}
                width={ICON_TITLE_HEIGHT}
                height={ICON_TITLE_HEIGHT}
                style={{ color: palette.secondary.main }}
              />
            }
            title={<Text tId="ADDITIONAL_INFORMATION" />}
            subtitle={<Text tId="ADDITIONAL_ADDRESS" />}
          />
          <AddressComplementForm />
        </Box>
        <AddressComplementFormSubmitter onSubmitForm={onSubmitForm} />
      </AddressComplementFormWrapper>
    </>
  );
}
